import React from 'react'
import Img from 'gatsby-image'
import { Link } from 'gatsby'

export default function ImageWithLink ( props ) {

	const { image, imageLinkUrl, imageLinkLabel, imageLinkExternal } = props.input

	const fluid = image?.imageFile?.childImageSharp?.fluid
	const isPortrait = fluid && fluid.aspectRatio <= 1

	return (
		<section className={`image-link wrapper ${ isPortrait ? 'image-link--portrait' : '' }`}>
			<div className="image-link__wrapper">

				{ fluid && <Img className="image-link__image" fluid={ fluid } /> }

				{ imageLinkUrl && imageLinkLabel &&
					<>
						{ imageLinkExternal ? (
							<a href={ imageLinkUrl } className="image-link__link" target="_blank" rel="noreferrer">
								{ imageLinkLabel }
							</a>
						) : (
							<Link to={ imageLinkUrl } className="image-link__link">
								{ imageLinkLabel }
							</Link>
						) }
					</>
				}
			</div>
		</section>
	)
}
